import React, { FC } from 'react';
import { Skeleton, useTheme } from '@mui/material';
import { DashboardCard } from '@monorepo/nova-ui';

export const StatisticCardSkeleton: FC = () => {
  const theme = useTheme();

  return (
    <DashboardCard
      sx={{
        flexDirection: 'column',
        flex: 1,
        minWidth: theme.breakpoints.up('sm') ? theme.spacing(40) : '100%',
        gap: 1,
      }}
    >
      {/* Label with tooltip */}
      <Skeleton variant="text" width="80%" height={20} />

      {/* Value */}
      <Skeleton
        variant="text"
        width="60%"
        height={theme.typography.pxToRem(22)}
        sx={{
          fontSize: theme.typography.pxToRem(22),
          fontWeight: theme.typography.fontWeightMedium,
        }}
      />
    </DashboardCard>
  );
};
